import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Services from '../components/Services';
import Features from '../components/Features';
import Process from '../components/Process';
import Stats from '../components/Stats';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-white"
    >
      <Header />
      <Hero />
      <Products />
      <Services />
      <Features />
      <Process />
      <Stats />
      <CTA />
      <Footer />
    </motion.div>
  );
};

export default LandingPage;